import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import AdminLayout from "@/components/AdminLayout";
import { Globe, Users, MessageSquare, Image, TrendingUp } from "lucide-react";

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API}/stats`);
        setStats(response.data);
      } catch (error) {
        console.error("Failed to fetch stats:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const statCards = stats ? [
    { label: "Universes", value: stats.universes, icon: Globe, color: "text-sky-500", bg: "bg-sky-500/10" },
    { label: "Characters", value: stats.characters, icon: Users, color: "text-emerald-500", bg: "bg-emerald-500/10" },
    { label: "Users", value: stats.users, icon: TrendingUp, color: "text-amber-500", bg: "bg-amber-500/10" },
    { label: "Comments", value: stats.comments, icon: MessageSquare, color: "text-purple-500", bg: "bg-purple-500/10" },
    { label: "Gallery Items", value: stats.gallery_items, icon: Image, color: "text-pink-500", bg: "bg-pink-500/10" },
  ] : [];

  return (
    <AdminLayout title="Dashboard">
      {loading ? (
        <div className="flex items-center justify-center py-20">
          <div className="spinner"></div>
        </div>
      ) : (
        <>
          {/* Stats Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
            {statCards.map((stat) => (
              <div key={stat.label} className="card-surface p-6" data-testid={`stat-${stat.label.toLowerCase()}`}>
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 rounded flex items-center justify-center ${stat.bg}`}>
                    <stat.icon className={`w-6 h-6 ${stat.color}`} />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-white font-['Outfit']">{stat.value}</div>
                    <div className="text-sm text-slate-400">{stat.label}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Quick Actions */}
          <div className="card-surface p-6">
            <h2 className="text-lg font-bold text-white mb-4 font-['Outfit']">Quick Actions</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <a href="/admin/universes" className="btn-secondary p-4 text-center hover:border-yellow-500/30">
                <Globe className="w-6 h-6 mx-auto mb-2 text-sky-500" />
                Add Universe
              </a>
              <a href="/admin/characters" className="btn-secondary p-4 text-center hover:border-yellow-500/30">
                <Users className="w-6 h-6 mx-auto mb-2 text-emerald-500" />
                Add Character
              </a>
              <a href="/admin/gallery" className="btn-secondary p-4 text-center hover:border-yellow-500/30">
                <Image className="w-6 h-6 mx-auto mb-2 text-pink-500" />
                Upload Media
              </a>
              <a href="/admin/content" className="btn-secondary p-4 text-center hover:border-yellow-500/30">
                <TrendingUp className="w-6 h-6 mx-auto mb-2 text-amber-500" />
                Generate Content
              </a>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  );
};

export default AdminDashboard;
